import { hideModal } from "../../../context/Actions/modal/modal";
import "./ModalAutorizarFamiliar.css";
import { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import isPwdValido from "../../../../global/utils/checkPwdValido";
import preventEletter from "../../../../global/utils/preventKey";
import {
  limpiarAddFamiliarClave,
  wsAutorizarFamiliar,
  wsGetGrupoFamiliar,
} from "../../../context/Actions/grupoFamiliar/grupoFamiliar";
import Loading from "../../Genericos/Loading/Loading";
import { IonSpinner } from "@ionic/react";
import HidePassIcon from "../../../assets/images/generico/HidePassIcon";
import ShowPassIcon from "../../../assets/images/generico/ShowPassIcon";
import InputV1 from "../../Genericos/InputV1/InputV1";
import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import { getListaFamiliares } from "_+_Portal/context/Actions/listaFamiliares/listasFamiliares";

// Este es el modal para desvincular
const ModalAutorizarFamiliar = ({ nombre, idFamiliar }) => {
  // nombre hace referencia al nombre del familiar
  const {
    modalDispatch,
    grupoFamiliarDispatch,
    grupoFamiliarState,
    listaFamiliaresDispatch,
  } = useContext(PortalContext);
  const { toasterDispatch } = useContext(GlobalContext);

  const [valuePwd, SetValuePwd] = useState("");
  const [pwdError, setPwdError] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);

  const postClaveFamiliarError =
    grupoFamiliarState.grupoFamiliar.postFamiliarClave.error;
  const postClaveFamiliarLoading =
    grupoFamiliarState.grupoFamiliar.postFamiliarClave.loading;
  useEffect(() => {
    if (postClaveFamiliarError) {
      setPwdError(true);
    } else {
      setPwdError(false);
    }
    if (
      !pwdError &&
      !postClaveFamiliarError &&
      !postClaveFamiliarLoading &&
      valuePwd !== ""
    ) {
      hideModal()(modalDispatch);
      limpiarAddFamiliarClave()(grupoFamiliarDispatch);
    }
  }, [postClaveFamiliarError, postClaveFamiliarLoading]);

  // cierra el modal
  const handleClickModal = () => {
    hideModal()(modalDispatch);
    limpiarAddFamiliarClave()(grupoFamiliarDispatch);

    // deleteVinculo(idpaciente1,idpaciente2)()
  };

  const autorizarClave = () => {
    if (valuePwd !== "") {
      wsAutorizarFamiliar(idFamiliar, valuePwd, (isCorrect, data) => {
        if (isCorrect) {
          showToaster(
            {
              texto: "El familiar fue autorizado correctamente.",
              tipo: "success",
            },
            "centroArriba"
          )(toasterDispatch);
          getListaFamiliares(true)(listaFamiliaresDispatch);
          wsGetGrupoFamiliar(true)(grupoFamiliarDispatch);
        }
      })(grupoFamiliarDispatch);
    } else {
      setPwdError(true);
    }
  };

  const onChangePwd = (e) => {
    setPwdError(!isPwdValido(e));
    SetValuePwd(e.target.value);
    if (isPwdValido(e)) {
      SetValuePwd(e.target.value);
    }
  };

  const showPassword = () => {
    setPasswordShown(true);
  };
  const hidePassword = () => {
    setPasswordShown(false);
  };

  // agrego la funcionalidad de enter
  const handleChangeKeyPress = (e) => {
    preventEletter(e);
    if (e.key === "Enter") autorizarClave();
  };
  return (
    <div className="ptur-modalAutorizarFamiliar-container">
      <div className="ptur-modalAutorizarFamiliar-header bgcG-latex30">
        <span className="rb18b">Ingresar clave de tu familiar</span>
        <span
          className="ptur-modalAutorizarFamiliar-header-cruz"
          onClick={handleClickModal}
        >
          X
        </span>
      </div>
      <div className="ptur-modalAutorizarFamiliar-body">
        <span className="ptur-modalAutorizarFamiliar-body-text">
          Para vincular a <span className="rb18m">{nombre}</span>, completá con
          la contraseña que utiliza tu familiar para ingresar a su cuenta del
          portal.
        </span>
        <div className="ptur-modalAutorizarFamiliar-body-contrasenia">
          <InputV1
            inputType="number"
            name="txtPwd"
            placeholderText="********"
            errorStr="La contraseña es inválida."
            onChange={onChangePwd}
            onKeyPress={handleChangeKeyPress}
            value={valuePwd}
            className={
              passwordShown
                ? "inputNumericShow inputNonScroll rb16m"
                : "inputNumeric inputNonScroll rb16m"
            }
            maxLength="10"
            checkError={pwdError}
            isRequired={true}
          />
          {passwordShown === false ? (
            <>
              <button
                className="ptur-modalAutorizarFamiliar-show-hideBtn"
                onClick={() => showPassword()}
              >
                <HidePassIcon color="var(--color-latex30)" />
              </button>
            </>
          ) : (
            <>
              <button
                className="ptur-modalAutorizarFamiliar-show-hideBtn"
                onClick={() => hidePassword()}
              >
                <ShowPassIcon color="var(--color-latex30)" />
              </button>
            </>
          )}
        </div>
        <div className="ptur-modalAutorizarFamiliar-body-btnContainer">
          <button
            className="ptur-modalAutorizarFamiliar-body-btn-disable"
            onClick={handleClickModal}
          >
            No, cancelar
          </button>
          {postClaveFamiliarLoading ? (
            <button className="ptur-modalAutorizarFamiliar-body-btn-red bgcG-latex30">
              <span className={"c-white"}>
                <IonSpinner name="lines" />
              </span>
            </button>
          ) : (
            <button
              className="ptur-modalAutorizarFamiliar-body-btn-red bgcG-latex30"
              onClick={() => autorizarClave()}
            >
              Confirmar
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalAutorizarFamiliar;
